// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2tsnh","large":"styles_large__N2aV8"};